import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import "../styles/Portfolio.css";

function PortfolioPage() {
  const projects = [
    {
      id: 1,
      title: "Chamaa",
      description: "Group savings and investment management platform",
      url: "https://chamha.online",
      technologies: ["React", "Node.js", "MongoDB"],
    },
    {
      id: 2,
      title: "Hotel POS System",
      description: "Point of sale system for hotel operations",
      url: "https://havenways.store",
      technologies: ["React", "Node.js", "MySQL"],
    },
    {
      id: 3,
      title: "PSAMS21 POS System",
      description: "Custom retail point of sale system",
      url: "https://psams21pos.co.ke",
      technologies: ["React", "Node.js", "PostgreSQL"],
    },
    {
      id: 4,
      title: "SunFlower Events",
      description: "Event planning and CRM platform",
      url: "https://event-crm-frontend-five.vercel.app",
      technologies: ["React", "Node.js", "MongoDB"],
    },
    {
      id: 5,
      title: "Havenways Company",
      description: "Corporate website and portfolio",
      url: "https://havenways.co.ke",
      technologies: ["React", "Tailwind CSS"],
    },
    {
      id: 6,
      title: "Haven Pay",
      description: "Secure payment processing platform",
      url: "https://havenpay-frontend.vercel.app",
      technologies: ["React", "Node.js", "Stripe"],
    },
    {
      id: 7,
      title: "Gadgets Grind",
      description: "E-commerce platform for electronics",
      url: "https://gadgetsgrind.co.ke",
      technologies: ["React", "Node.js", "MongoDB"],
    },
    {
      id: 8,
      title: "Kaptagat Education",
      description: "School website with student portal",
      url: "https://kaptagateducationcentre.sc.ke",
      technologies: ["React", "Tailwind CSS"],
    },
    {
      id: 9,
      title: "Litematt Enterprises",
      description: "Business portfolio website",
      url: "https://litemattenterprises.co.ke",
      technologies: ["React", "Tailwind CSS"],
    },
    {
      id: 10,
      title: "Cozy Care World",
      description: "Healthcare and wellness platform",
      url: "https://cozycare.world",
      technologies: ["React", "Node.js", "MongoDB"],
    },
    {
      id: 11,
      title: "Igitego Hotel",
      description: "Hotel booking and reservation system",
      url: "https://apart.igitegohotel.com",
      technologies: ["React", "Node.js", "Firebase"],
    },
    {
      id: 12,
      title: "Esiden Supply",
      description: "Supply chain management platform",
      url: "https://esiden.org",
      technologies: ["React", "Node.js", "PostgreSQL"],
    },
  ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <h1>Portfolio</h1>
          <p>Selected projects built for various clients</p>
        </div>

        <div className="portfolio-grid">
          {projects.map((project) => (
            <a
              key={project.id}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-item"
            >
              <div className="item-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="item-tech">
                  {project.technologies.map((tech, idx) => (
                    <span key={idx}>{tech}</span>
                  ))}
                </div>
              </div>
              <div className="item-link">
                <FaExternalLinkAlt />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PortfolioPage;
